import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AlertCircle, Loader2 } from 'lucide-react';
import { api, tokenStore } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const token = params.get('token');
    if (!token) {
      setError('Token ausente no link.');
      return;
    }

    (async () => {
      try {
        const res = await api.auth.verify(token);
        tokenStore.set(res.token);
        await refresh();
        // pequeno delay pra garantir flush do state do React antes da navegacao
        await new Promise((r) => setTimeout(r, 0));
        navigate('/', { replace: true });
      } catch (e) {
        const msg = e instanceof Error ? e.message : 'Erro desconhecido.';
        setError(msg);
      }
    })();
  }, [params, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-gradient-to-br from-bg via-blue-dark/30 to-bg">
      <div className="w-full max-w-md text-center">
        {error ? (
          <div className="bg-panel border border-border rounded-2xl p-8">
            <div className="inline-flex w-14 h-14 rounded-full bg-red/15 items-center justify-center mb-4">
              <AlertCircle className="w-8 h-8 text-red" />
            </div>
            <h2 className="text-lg font-semibold mb-2">Nao foi possivel autenticar</h2>
            <p className="text-sm text-muted mb-6">{error}</p>
            <button onClick={() => navigate('/login', { replace: true })} className="btn-secondary">
              Voltar pro login
            </button>
          </div>
        ) : (
          <div className="bg-panel border border-border rounded-2xl p-8">
            <div className="inline-flex w-14 h-14 rounded-full bg-blue/15 items-center justify-center mb-4">
              <Loader2 className="w-8 h-8 text-blue-light animate-spin" />
            </div>
            <h2 className="text-lg font-semibold mb-1">Validando seu link...</h2>
            <p className="text-sm text-muted">So um instante.</p>
          </div>
        )}
      </div>
    </div>
  );
}
